function validateAccessCode() {
    const codeInput = document.getElementById('access-code-input');
    const codeErrorMessage = document.getElementById('access-code-error');

    if (codeInput && codeInput.value === '') {
        if (codeInput.classList.contains('email_access')) {
            codeErrorMessage.innerHTML = '<br>Please enter your email address to continue.';
        } else {
            codeErrorMessage.innerHTML = '<br>Please enter the access code to continue.';
        }
        codeInput.focus();
        return false;
    }
    return true;
}

function validateAgeGate() {
    const ageMonth = document.getElementById('age-mm');
    const ageDay = document.getElementById('age-dd');
    const codeErrorMessage = document.getElementById('access-code-error');

    if (ageMonth) {
        let invalidFormatValueFound = false;

        // make month and days two characters in case they wrote only one number
        if (ageMonth.value.length === 1) {
            ageMonth.value = `0${ageMonth.value}`;
        }
        if (ageDay && ageDay.value.length === 1) {
            ageDay.value = `0${ageDay.value}`;
        }

        const ageInputs = document.getElementsByClassName('age-input');

        Array.prototype.forEach.call(ageInputs, (ageInput) => {
            if (ageInput && ageInput.value.length !== ageInput.maxLength) {
                codeErrorMessage.innerHTML = 'Please enter a valid date of birth.';
                ageInput.focus();
                invalidFormatValueFound = true;
            }
        });

        if (invalidFormatValueFound) {
            return false;
        }
    }
    return true;
}

export default () => {
    const ageInputs = document.getElementsByClassName('age-input');
    Array.prototype.forEach.call(ageInputs, (ageInput) => {
        ageInput.addEventListener('keydown', (event) => {
            const charCode = event.keyCode || event.which;

            if (charCode === 13) {
                if (ageInput.id === 'age-yy') {
                    document.getElementById('access-code-form').submit();
                } else {
                    event.preventDefault();
                    event.stopPropagation();

                    const nextInput = ageInput.nextElementSibling;
                    nextInput && nextInput.focus();
                }
            }
        });

        ageInput.addEventListener('keyup', (event) => {
            const charCode = event.keyCode || event.which;
            // allow backspace,delete,tab,period,left,right,comma
            const allowed = [46, 8, 9, 188, 37];

            if (ageInput.value.length === ageInput.maxLength) {
                if (allowed.indexOf(charCode) === -1) {
                    const nextInput = ageInput.nextElementSibling;
                    nextInput && nextInput.focus();
                }
            }
        });
    });

    const accessCodeForm = document.getElementById('access-code-form');
    accessCodeForm.addEventListener('submit', (event) => {
        if (validateAccessCode() === false || validateAgeGate() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
    });
};
